import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Moment from 'moment';

import { Typography, Table, Select, Button, Tooltip, Space, notification, Popconfirm, Collapse, Col, Row } from 'antd';
import { InfoCircleOutlined, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
// import Highlighter from 'react-highlight-words';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';
import { startLoading, endLoading } from '../../../shared/utility';

import * as storeActions from './store/actions/extra_charges';

import Loader from '../../common/PageElements/Loader';
import Reloader from '../../common/PageElements/Reloader';
import DropdownMenu from '../../common/components/DropdownMenu'
import ExtraChargeDrawer from './components/ExtraChargeDrawer'

import TableFilters from '../../common/components/TableFilters';

class ExtraChargesList extends Component {
   state = {
      localPath: this.props.history.location.pathname,
      getError: false,
      pageLoader: true,
      tableLoader: false,
      multipleActionLoader: false,
      loadersExtraCharges: [],
      parentId: null,
      itemList: [],
      fullListIds: [],
      componentLanguage: this.props.authState.defaultLanguage,
      current_page: this.props.location.state ? this.props.location.state.previousState.current_page : 1,
      page_size: this.props.location.state ? this.props.location.state.previousState.page_size : 50,
      total_result: 0,

      showTableFilters: false,
      filters: this.props.location.state ? this.props.location.state.previousState.filters : [],
      filtersValues: this.props.location.state ? this.props.location.state.previousState.filtersValues : {},
      appliedFilters: this.props.location.state ? this.props.location.state.previousState.appliedFilters : [],

      selectedRowKeys: [],
      selectedAll: false,
      multipleActionList: [
         {
            action: 'export_csv',
            name: 'Esporta selezionati in CSV'
         },
         // {
         //    action: 'delete_multiple',
         //    name: 'Cancella fornitori',
         //    needconfirmation: 'yes',
         // },
      ],
      importDropdownActionList: [],
   };

   getExtraChargesList = (page, pageSize, filters) => {
      // asyncronous calls
      this.setState({ tableLoader: true })
      return storeActions.getListExtended(page, pageSize, filters)
         .then(response => {
            console.log(response);
            try {
               this.setState({
                  itemList: response.data.data,
                  fullListIds: response.full_list_ids,
                  current_page: page,
                  page_size: pageSize,
                  total_result: response.data.total,
                  filters: response.list_filters,
                  appliedFilters: response.applied_filters,
                  tableLoader: false
               });
            } catch (e) {
               this.setState({ tableLoader: false })
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                  duration: 0,
               })
            }

         }).catch((e) => {
            this.setState({ getError: true });
            if (this.props.commonState.debug) console.log(e);
         });
   }

   prepareImportDropdown = () => {
      let newImport = {}
      let newImportDropdownActionList = []
      // console.log('prepareImportDropdown', this.props.authState.userData)
      _.forEach(this.props.authState.userData.activeMarketplaces, (marketplace) => {
         switch (marketplace.marketplace_base.alias) {
            case 'privalia':
               break
            case 'woocommerce':
               newImport = {
                  action: 'import_from_marketplace',
                  name: 'Importa dati da ' + marketplace.name,
                  params: {
                     marketplace_id: marketplace.id
                  },
                  needconfirmation: 'yes',
               }
               newImportDropdownActionList.push(newImport)
               break
         }
      })
      this.setState({
         importDropdownActionList: newImportDropdownActionList,
      });
   }

   componentDidMount() {
      console.log('Component Did Mount - ExtraCharges List')
      Promise.all([
         this.getExtraChargesList(this.state.current_page, this.state.page_size, this.state.filtersValues),
         // this.getComplements()
      ]).then(() => {
         this.setState({
            pageLoader: false
         });
      }).catch(error => {
         console.error('Mount error: ', error.message)
      });
      // if (!_.isNil(this.props.authState.userData.activeMarketplaces)) {
      //    this.prepareImportDropdown()
      // }
   }
   // componentDidUpdate(prevProps) {
   //    if (this.props.authState.userData.activeMarketplaces !== prevProps.authState.userData.activeMarketplaces) {
   //       this.prepareImportDropdown()
   //    }
   // }

   // editItemHandler = (itemId) => {
   //    this.props.history.push({
   //       pathname: itemId ? '/extracharges/edit/' + itemId : '/extracharges/edit/',
   //       state: { previousState: this.state }
   //    });
   // }

   deleteMultipleItemsHandler = (itemIds) => {
      // this.setState({ loader: true });
      // storeActions.deleteMultipleItems(productIds, true)
      //    .then(response => {
      //       console.log(response);
      //       try {
      //          // let list = [...this.state.itemList];
      //          // list = list.filter(item => item.id !== itemId);

      //          this.getProductsList(this.state.current_page, this.state.page_size, this.state.filtersValues);
      //          notification.open({
      //             message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
      //             description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
      //             icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
      //          })
      //       } catch (e) {
      //          notification.open({
      //             message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
      //             description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
      //             icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
      //          })
      //       }

      //    }).catch((e) => {
      //       notification.open({
      //          message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
      //          description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
      //          icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
      //       })
      //       if (this.props.commonState.debug) console.log(e);
      //    });
   }

   deleteItemHandler = (itemId) => {
      this.setState({ loadersExtraCharges: startLoading(this.state.loadersExtraCharges, itemId) });
      storeActions.deleteItem(itemId, true)
         .then(response => {
            console.log(response);
            try {
               Promise.all([
                  this.getExtraChargesList(this.state.current_page, this.state.page_size, this.state.filtersValues)
               ]).then(() => {
                  this.setState({ loadersExtraCharges: endLoading(this.state.loadersExtraCharges, itemId) });
               });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
            }

         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   confirmHandler = (onConfirm, itemIds) => {
      switch (onConfirm) {
         case 'deleteItem':
            if (itemIds) {
               this.deleteItemHandler(itemIds);
            }
            break;
         default:
            break;
      }
   }

   extrachargesExportHandler = (marketplace, supplierIds, params) => {
      let filename
      switch (marketplace) {
         case 'nzt':
            this.setState({ multipleActionLoader: true });
            filename = Moment().format('YYYY.MM.DD-HH.mm.ss') + '_EXTRACHARGES.csv';
            storeActions.exportCSV(filename, supplierIds)
               .then(response => {
                  this.setState({ multipleActionLoader: false });
                  console.log(response);
                  try {
                     this.setState({ loader: false });
                  } catch (e) {
                     notification.open({
                        message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                        description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                        icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                     })
                  }

               }).catch((e) => {
                  this.setState({ multipleActionLoader: false });
                  notification.open({
                     message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                     description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
                     icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                  })
                  if (this.props.commonState.debug) console.log(e);
               });
            break;
         default:
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.no_marketplace_selected'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            break;
      }
   }

   onSelectChange = (selectedRowKeys) => {
      this.setState({
         selectedRowKeys: selectedRowKeys
      });
      console.log(selectedRowKeys);
   };

   submitFilters = (values) => {
      this.setState({ filtersValues: values })
      this.getExtraChargesList(this.state.current_page, this.state.page_size, values)
   }
   resetFilters = () => {
      this.getExtraChargesList(this.state.current_page, this.state.page_size, []);
   }

   selectAllHandler = () => {
      if (this.state.selectedAll) {
         this.setState({
            selectedAll: false,
            selectedRowKeys: [],
         });
      }
      else {
         this.setState({
            selectedAll: true,
            selectedRowKeys: this.state.fullListIds,
         });
      }
   }
   multipleActionHandler = (value) => {
      console.log(value)
      const props = value.item.props
      switch (props.action) {
         case 'export_csv':
            this.extrachargesExportHandler('nzt', this.state.selectedRowKeys);
            break;
         case 'delete_multiple':
            this.deleteMultipleItemsHandler(this.state.selectedRowKeys);
            break;
         default:
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            break;

      }
   }

   handleTableChange = (pagination, filters, sorter, extra) => {
      console.log(pagination, filters, sorter, extra);
      this.getExtraChargesList(pagination.current, pagination.pageSize, this.state.filtersValues);
   };


   editItemHandler = item => {
      this.setState({ itemExtraChargeDrawer: item, showExtraChargeDrawer: true })
   }
   showExtraChargeDrawer = () => {
      this.setState({ itemExtraChargeDrawer: null, showExtraChargeDrawer: true })
   }
   hideExtraChargeDrawer = () => {
      this.setState({ itemExtraChargeDrawer: null, showExtraChargeDrawer: false })
   }
   handleCreateExtraCharge = (ExtraCharges_list) => {
      console.log('Elemento creato correttamente')
      var newFormValues = { ...this.state.formValues }
      newFormValues.ExtraCharges = ExtraCharges_list
      this.setState({ formValues: newFormValues, itemExtraChargeDrawer: null, showExtraChargeDrawer: false })
   }

   render() {
      console.log('ExtraCharges list RENDER');
      if (this.state.getError) return <Reloader />;
      if (this.state.pageLoader) return <Loader />;
      const { Title } = Typography
      const { Option } = Select;
      const { Panel } = Collapse;

      const table_columns = [
         {
            title: 'Applica a ordini',
            key: 'apply_on_charging',
            width: 100,
            fixed: 'left',
            align: 'center',
            render: (record) => (
               record.apply_on_charging ? 'Entrata' : 'Uscita'
            ),
            sorter: (a, b) => Number(a.apply_on_charging) - Number(b.apply_on_charging),
         },
         {
            title: 'Nome',
            key: 'name',
            fixed: 'left',
            width: 250,
            render: (record) => (
               record.name
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
         },
         {
            title: 'Descrizione',
            key: 'description',
            render: (record) => (
               record.description
            ),
            sorter: (a, b) => a.description.localeCompare(b.description),
         },
         {
            title: 'Applica a quantità',
            key: 'auto_apply_on_quantity',
            width: 100,
            align: 'center',
            render: (record) => (
                  <Button type={record.auto_apply_on_quantity ? 'success' : 'danger'} size="small"
                     icon={record.auto_apply_on_quantity ? <CheckOutlined /> : <CloseOutlined />}
                  />
            ),
         },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  <Button type="primary" size='small'
                     disabled={this.state.loadersExtraCharges[record.id]}
                     icon={<EditOutlined />}
                     onClick={() => this.editItemHandler(record)}
                  />
                  {/* <Dropdown.Button type="primary" onClick={() => this.editItemHandler(record.id)} overlay={actionsMenu(record.id)}><EditOutlined /></Dropdown.Button> */}
                  <Popconfirm
                     placement="topRight"
                     title={languageManager.getMessage(this.props.commonState, 'common.askDeleteConfirm')}
                     onConfirm={() => this.confirmHandler('deleteItem', record.id)}
                     okText={languageManager.getMessage(this.props.commonState, 'common.yes')}
                     cancelText={languageManager.getMessage(this.props.commonState, 'common.no')}
                  >
                     <Button type="danger" size='small'
                        loading={this.state.loadersExtraCharges[record.id]}
                        icon={<DeleteOutlined />}
                     />
                  </Popconfirm>
               </Space>),
         },
      ];
      const tableLayout = {
         bordered: true,
         size: "small",
         loading: this.state.tableLoader,
         pagination: {
            pageSize: this.state.page_size,
            total: this.state.total_result,
            showSizeChanger: true,
            defaultPageSize: 50,
            size: "small",
            showTotal: total => total + (total !== 1 ? ' clienti' : ' cliente')
         },
         onChange: this.handleTableChange
      }
      const { selectedRowKeys } = this.state;
      const rowSelection = {
         selectedRowKeys,
         onChange: this.onSelectChange,
         preserveSelectedRowKeys: true
      };

      const pageFilters = (
         <Collapse defaultActiveKey={['filters']}>
            <Panel header="Filtri" key="filters">
               <TableFilters submitFilters={this.submitFilters} resetFilters={this.resetFilters} filters={this.state.filters} selectValues={this.state.filtersValues} />
            </Panel>
         </Collapse>
      );

      const hasSelected = selectedRowKeys.length > 0;
      const singleSelected = selectedRowKeys.length > 1;
      const pageContent = (
         <div className="card">
            <div className="card-header">
               <div className="align-items-center row">
                  <div className="col-sm-6">
                     <Title level={5}>{languageManager.getMessage(this.props.commonState, 'component.extra_charges.title')}</Title>
                  </div>
                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">
                        <Space>
                           <Button
                              type='primary'
                              icon={<PlusOutlined />}
                              // onClick={this.showCreateSupplierDrawer}
                              onClick={() => this.editItemHandler()}
                           >
                              {languageManager.getMessage(this.props.commonState, 'component.extra_charges.create_new')}
                           </Button>
                        </Space>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card-body">
               <Row>
                  <Col span={24}>
                     {pageFilters}
                  </Col>
               </Row>
               <Row>
                  <Col span={24}>
                     <div className="align-items-center row" style={{ marginTop: 15, marginBottom: 5 }}>
                        <div className="col-sm-12">
                           <div className="d-none d-md-block">
                              <Space>
                                 <Button
                                    onClick={() => this.selectAllHandler()}
                                    disabled={_.isEmpty(this.state.fullListIds)}
                                 >{this.state.selectedAll ? 'Deseleziona' : 'Seleziona tutto'}
                                 </Button>
                                 <span>
                                    {hasSelected ? singleSelected ? `${selectedRowKeys.length} elementi selezionati` : `${selectedRowKeys.length} elemento selezionato` : ''}
                                 </span>
                                 <DropdownMenu
                                    type='primary'
                                    title='Azioni multiple'
                                    action={(event) => this.multipleActionHandler(event)}
                                    values={this.state.multipleActionList}
                                    disabled={!hasSelected}
                                    loading={this.state.multipleActionLoader}
                                 />
                              </Space>
                           </div>
                        </div>
                     </div>
                     <Table
                        key='dataTable'
                        {...tableLayout}
                        rowSelection={rowSelection}
                        columns={table_columns}
                        dataSource={this.state.itemList}
                        rowKey={record => (record.id)}
                     />,
                     <ExtraChargeDrawer
                        key='ExtraChargeDrawer'
                        visible={this.state.showExtraChargeDrawer}
                        itemId={this.state.itemId}
                        item={this.state.itemExtraChargeDrawer}
                        onClose={this.hideExtraChargeDrawer}
                        onSubmit={(extracharges_list) => this.handleCreateExtraCharge(extracharges_list)} />
                  </Col>
               </Row>
            </div>
            <div className="card-footer">
               <Button
                  size='large'
                  onClick={() => { this.props.history.goBack() }}
               >
                  <i className="mdi mdi-arrow-left-drop-circle-outline mr-1"></i>
                  {languageManager.getMessage(this.props.commonState, 'common.back')}
               </Button>
            </div>
         </div>
      );

      return (
         <div className="container-fluid">
            <div className="row">
               <div className="col">
                  {pageContent}
               </div>
            </div>
         </div>
      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState,
   };
};

export default connect(mapStateToProps)(ExtraChargesList);